import {
  RecommendationPayload,
  RecommendationResponse,
} from '../../types/common';
import { Product } from '../../types/product.types';
import { getRecommendationPieceResultV2 } from '../../utils/helper';
import RecommendationErrorHandler from '../Error/RecommendationErrorHandler';
import ProductService from '../product/product.service';
import RecommendationServices from '../recommendation/recommendations.service';

export async function boughTogetherRecommendations(
  payload: RecommendationPayload,
  assignRecommendationData?: (rProducts: RecommendationResponse) => void,
  mmid?: string,
): Promise<RecommendationResponse> {
  const data = await RecommendationServices.getFrequentlyBoughtTogetherRecommendationProduct(payload);

  assignRecommendationData?.(data as any);

  const productIds = data?.products?.map((x) => x.id);
  const productsData = await ProductService.getProductsByIdsV2(
    productIds,
    payload.storeCodes ?? [],
    payload?.isExpressMode,
    payload?.isSameDay,
    undefined,
    undefined,
    payload?.countryCode as any,
    undefined,
    mmid,
    payload?.afcStoreCodes,
    payload?.isAfcStoreEnabled,
    payload?.userSegments,
    payload?.isHorecaMemberEnabled,
  );
  const recommendProducts = getRecommendationPieceResultV2(
    data.products,
    productsData as Product[],
    payload?.recommendationStoreCodes ?? payload?.storeCodes ?? [],
    payload?.isExpressMode ?? false,
    payload?.hasAlcoholProductAvailability,
  ) as Product[];

  if (productIds?.length !== 0) {
    return {
      products: recommendProducts || [],
      recommendationType: data.recommendationType,
      totalCount: data.totalCount,
      actualCount: productIds?.length,
      algorithm: data.algorithm,
      personalised: data?.personalised,
    };
  } else {
    return RecommendationErrorHandler.getDefaultErrorResponse();
  }
}
